import {Trans} from '@lingui/macro';
import React from 'react';

import {RuleEditorActionsGroupsEnum} from '../ruleActionModel';
import {StyledDropdownGroupTitleWrapper} from './ruleEditorCommons';

/*
 * Types.
 */

interface RuleActionGroupTitleProps {
  id: RuleEditorActionsGroupsEnum;
}

/*
 * Component.
 */

export const RuleActionGroupTitle = ({id}: RuleActionGroupTitleProps) => (
  <StyledDropdownGroupTitleWrapper>{getTitle(id)}</StyledDropdownGroupTitleWrapper>
);

/*
 * Helpers.
 */

const getTitle = (id: RuleEditorActionsGroupsEnum) => {
  switch (id) {
    case RuleEditorActionsGroupsEnum.TEAMMATES:
      return <Trans id="rule-editor-actions-group-teammates">Teammates</Trans>;

    case RuleEditorActionsGroupsEnum.STATUS:
      return <Trans id="rule-editor-actions-group-status">Status</Trans>;

    case RuleEditorActionsGroupsEnum.ORGANIZATION:
      return <Trans id="rule-editor-actions-group-organization">Organization</Trans>;

    case RuleEditorActionsGroupsEnum.MESSAGE:
      return <Trans id="rule-editor-actions-group-message">Message</Trans>;

    case RuleEditorActionsGroupsEnum.COMMENT:
      return <Trans id="rule-editor-actions-group-comment">Comment</Trans>;

    case RuleEditorActionsGroupsEnum.CONTACTS:
      return <Trans id="rule-editor-actions-group-contacts">Contacts</Trans>;

    case RuleEditorActionsGroupsEnum.THIRD_PARTY:
      return <Trans id="rule-editor-actions-group-teammates-3rd-party">3rd party</Trans>;

    case RuleEditorActionsGroupsEnum.ACCOUNT:
      return <Trans id="rule-editor-actions-group-account">Account</Trans>;

    default:
      return id;
  }
};
